import * as types from '../mutation-types';

const state = {
  leftDrawer: false,
  menu: {
    dashboard: false,
    accounts: false,
    adverts: false,
    customers: false,
    funders: false,
    partners: false,
    banks: false,
    referrals: false,
    dialler: false,
    billing: false,
    reports: false,
    questions: false,
    platforms: false,
    brokers: false
  },
  filter: {
    hotProspect: false,
    bankDecline: false,
    brokerReferral: false,
    toBeCalled: false,
    eliteReferral: false,
    referral: false,
    notReferral: false,
    trustPilot: false,
    financialsSent: false,
    autoSendEnquiries: false,
    notAutoSendEnquiries: false,
    questionsIncomplete: false,
    questionsComplete: false,
    closed: false,
    noEnquiries: false,
    hasDocuments: false,
    newsletterSignup: false,
    noEmail: false,
    withEmail: false,
    noPhone: false
  }
};

const getters = {
  UILeftDrawer: state => state.leftDrawer,
  UIMenuOptions: state => state.menu,
  UIFilterOptions: state => state.filter
};

const actions = {
  updateUILeftDrawerState({ commit }, drawerState) {
    commit(types.TOGGLE_LEFT_DRAWER, drawerState);
  },
  uiEnableMenuOption({ commit }, option) {
    commit(types.UI_ENABLE_MENU_OPTION, option);
  },
  uiEnableFilterOption({ commit }, option) {
    commit(types.UI_ENABLE_FILTER_OPTION, option);
  }
};

const mutations = {
  [types.TOGGLE_LEFT_DRAWER](state, drawerState) {
    state.leftDrawer = drawerState;
  },
  [types.UI_ENABLE_MENU_OPTION](state, option) {
    state.menu[option] = true;
  },
  [types.UI_ENABLE_FILTER_OPTION](state, option) {
    state.filter[option] = true;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
